import classNames from "classnames"
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ButtonPrev } from "@UI/Button";
import PageTitle from "@UI/New/PageTitle";
import { routes } from "@/routes/list";
import s from "./index.module.css";

const ignoredPathSegments = [/^\d+$/, /^course-or-group-/, /^block-/, /^[0-9a-f-]{24,}$/i];

const pathSegmentLabels = {
    admin: "Администрирование",
    courses: "Курсы",
    course: "Курс",
    my: "Мои курсы",
    all: "Все курсы",
    platform: "Платформа",
    settings: "Настройки",
    platformSettings: "Настройки платформы",
    users: "Пользователи",
    students: "Ученики",
    parents: "Родители",
    colleges: "Коллеги",
    reports: "Отчеты",
    timetable: "Расписание",
    lessons: "Занятия",
    homework: "Домашняя работа",
    dz: "Задания",
    taskBank: "Банк задач",
    taskbank: "Банк задач",
    journal: "Журнал",
    profile: "Профиль",
    payment: "Оплата",
    news: "Новости",
};

const getSegmentLabel = (segment) => {
    const decodedSegment = decodeURIComponent(segment);
    const normalizedSegment = decodedSegment.replace(/[-_]/g, " ");

    return pathSegmentLabels[segment] || normalizedSegment.charAt(0).toUpperCase() + normalizedSegment.slice(1);
};

const isIgnoredSegment = (segment) => ignoredPathSegments.some((pattern) => pattern.test(segment));

const getRouteLabel = (path) => routes.find((route) => route.path === path)?.label;

/**
 * @param {{ title?: string, className?: string }} props
 */
const PageBreadcrumbs = ({ title = "", className = undefined }) => {
    const isBreadcrumbsEnabled = useSelector((store) => store.settings.isBreadcrumbsEnabled === "1");
    const { pathname } = useLocation();

    if (!isBreadcrumbsEnabled) {
        return null;
    }

    const pathSegments = pathname.split("/").filter(Boolean);

    if (!pathSegments.length) {
        return null;
    }

    const breadcrumbs = [{ label: "Главная", to: "/" }];
    let currentPath = "";

    pathSegments.forEach((segment) => {
        currentPath += `/${segment}`;

        if (segment === "v2" || isIgnoredSegment(segment)) {
            return;
        }

        breadcrumbs.push({
            label: getRouteLabel(currentPath) || getSegmentLabel(segment),
            to: currentPath,
        });
    });

    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

    if (title && lastBreadcrumb?.label !== title) {
        breadcrumbs.push({ label: title });
    }

    const visibleBreadcrumbs = breadcrumbs.length > 3
        ? [breadcrumbs[0], ...breadcrumbs.slice(-2)]
        : breadcrumbs;

    return (
        <nav className={classNames(s.breadcrumbs, className)} aria-label="Хлебные крошки">
            {visibleBreadcrumbs.map((item, index) => {
                const isLast = index === visibleBreadcrumbs.length - 1;

                return (
                    <span className={s.breadcrumbItem} key={`${item.label}-${index}`}>
                        {isLast || !item.to ? (
                            <span className={s.breadcrumbCurrent}>{item.label}</span>
                        ) : (
                            <Link className={s.breadcrumbLink} to={item.to}>
                                {item.label}
                            </Link>
                        )}
                    </span>
                );
            })}
        </nav>
    );
};

const HeaderWithBackButton = ({ children, className, title = "" }) => (
    <div className={classNames('newDesignHeader', className)}>
        {children}
    </div>
);

export default HeaderWithBackButton;


const HeaderWithBackButtonDefault = ({ className, title='', link = '/', linkForsed = null }) => (
    <div className={classNames('newDesignHeader', className)}>
        <ButtonPrev link={link} linkForsed={linkForsed} newDesign={true} />
        <PageTitle title={title} />
        <PageBreadcrumbs title={title} />
    </div>
);

export { HeaderWithBackButtonDefault, PageBreadcrumbs };
